import { FormikHelpers, useFormik } from 'formik';
import { IAddSponsorState } from 'store';

const useAddAdsForm = (
  onSubmit: (
    values: IAddSponsorState,
    formikHelpers: FormikHelpers<IAddSponsorState>,
  ) => void | Promise<unknown>,
  initialValues: IAddSponsorState,
  validationSchema: any,
) => {
  return useFormik<IAddSponsorState>({
    initialValues,
    validationSchema,
    validateOnChange: true,
    enableReinitialize: true,
    validateOnBlur: true,
    onSubmit,
  });
};

export default useAddAdsForm;
